var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isLoading,
          expression: "isLoading"
        }
      ],
      staticClass: "Edit"
    },
    [
      _c(
        "el-header",
        { staticClass: "Edit-header" },
        [
          _c("el-page-header", {
            attrs: { content: _vm.title },
            on: { back: _vm.close }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-main",
        { staticClass: "Edit-main" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "150px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "500px" },
                  attrs: { label: "名称", prop: "name" }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.name,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "500px" },
                  attrs: { label: "是否允许透支", prop: "name" }
                },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.form.overdraft,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "overdraft", $$v)
                        },
                        expression: "form.overdraft"
                      }
                    },
                    [
                      _c("el-option", { attrs: { label: "否", value: 0 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "是", value: 1 } })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "500px" },
                  attrs: { label: "描述", prop: "remark" }
                },
                [
                  _c("el-input", {
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.form.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.submitForm("form")
                        }
                      }
                    },
                    [_vm._v("提交")]
                  ),
                  _vm._v(" "),
                  _vm.isModel !== 2
                    ? _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.resetForm("form")
                            }
                          }
                        },
                        [_vm._v("重置")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0aeefe7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0aeefe7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ad_owner/Edit.vue
// module id = m1qQ
// module chunks = 1